// extracted by mini-css-extract-plugin
export default {"sessionContainer":"SessionTimeout_sessionContainer__cf5l+","heading":"SessionTimeout_heading__ZRmRF","info":"SessionTimeout_info__HC7kd","link":"SessionTimeout_link__dnoGk"};